import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "medal.icon",
  "use": "medal.icon-usage",
  "viewBox": "-3925.453 -11773.5 22.306 34.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3925.453 -11773.5 22.306 34.5\" id=\"medal.icon\"><path data-name=\"Path 562\" d=\"M165.929,177.155a1.248,1.248,0,0,0,.3-.781,1.167,1.167,0,0,0-1.172-1.172h-1.215l7.161-12.8H164.67l-4.817,8.636-4.817-8.636H148.7l7.117,12.8H154.6a1.167,1.167,0,0,0-1.172,1.172,1.248,1.248,0,0,0,.3.781,10.807,10.807,0,1,0,16.882,8.94A10.583,10.583,0,0,0,165.929,177.155ZM159.9,194.948a8.768,8.768,0,0,1-6.249-2.6,8.936,8.936,0,0,1-2.6-6.162v-.174a8.875,8.875,0,0,1,8.81-8.679,8.81,8.81,0,1,1,.043,17.619Zm-5.859-30.812,6.206,11.153h-2.387l-6.206-11.153Zm14.061,0L161.936,175.2l-1.215-2.17,4.947-8.9Z\" transform=\"translate(-4074.153 -11935.9)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/medal.icon.svg
// module id = NT4U
// module chunks = 13